import { BalanceInfoComponent } from './../balance-info/balance-info.component';
import { Component, OnInit, Input, Injector } from '@angular/core';
import { DataService } from '../../services/data/data.service';
import { MainUIServiceService } from '../../services/main-uiservice.service';

@Component({
  selector: 'mobile-balance-info',
  template: require('./mobile-balance-info.component.html'),
  styles: [require('./mobile-balance-info.component.css')]
})
export class MobileBalanceInfoComponent extends BalanceInfoComponent implements OnInit {

private _type = "";
  @Input() public set type(v:any)
  {
      this._type = v
  }

  constructor(injector: Injector, protected  dataService: DataService,protected mainUIService:MainUIServiceService )
  {
    super(injector, dataService, mainUIService)

  }

ngOnInit()
{
  // console.log("type....")
  // console.log(this.workspace.activeOrderTab);
}

get accounts()
{
    return this.workspaceService.data.accounts;
}

switchAccount(account: Account)
    {

      this.dataService.sendRequest({
          Cmd: DataService.TYPE_SWITCHACCOUNT,
          Data: {AccountId: account.id}
      });

    this.workspaceService.data.activeAccountIdBySet = Number(account.id);

    }
}
